import { Alert, Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import { ADFPaymentRequest, PaymentType } from '@/models/Payment';

import CreditCardPayment from './CreditCardPayment';
import OnAccountPayment from './OnAccountPayment';

function Payment({
  paymentRequest,
  errorMessage,
  onChange,
  submitted,
}: {
  paymentRequest: ADFPaymentRequest;
  errorMessage: string | null;
  onChange: (paymentRequest: ADFPaymentRequest) => void;
  submitted: boolean;
}) {
  const handlePaymentTypeChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedPaymentRequest = {
      ...paymentRequest,
      paymentType: parseInt(event.target.value),
    };
    onChange(updatedPaymentRequest);
  };

  const handleCreditCardChanged = (updatedPaymentRequest: ADFPaymentRequest) =>
    onChange(updatedPaymentRequest);

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant='h4'>Payment</Typography>
      {errorMessage && (
        <Alert sx={{ my: 1 }} severity='error'>
          {errorMessage}
        </Alert>
      )}
      <Typography sx={{ mt: 1 }} variant='adfBody1'>
        Application Fee: <strong>${paymentRequest.paymentAmount}</strong>
      </Typography>
      <Typography sx={{ mt: 3 }} variant='h5'>
        Payment Method
      </Typography>
      <RadioGroup
        sx={{ mt: 1 }}
        row
        value={paymentRequest.paymentType}
        onChange={handlePaymentTypeChanged}
      >
        <FormControlLabel value={PaymentType.CreditCard} control={<Radio />} label='Credit Card' />
        <FormControlLabel value={PaymentType.OnAccount} control={<Radio />} label='Invoice Me' />
      </RadioGroup>
      <Box sx={{ mt: 2 }}>
        {paymentRequest.paymentType === PaymentType.CreditCard && (
          <CreditCardPayment
            paymentRequest={paymentRequest}
            onChange={handleCreditCardChanged}
            submitted={submitted}
          />
        )}
        {paymentRequest.paymentType === PaymentType.OnAccount && <OnAccountPayment />}
      </Box>
    </Box>
  );
}

export default Payment;
